/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Asset {
  id?: number;
  active?: boolean;
  code?: string;
  name?: string;
  qtyScale?: number;
  refPriceUsd?: number;
  minBalanceAlert?: number;
  maxBalanceAlert?: number;
}
